<ml-card-container [title]="'application.history.title' | translate" [icon]="'clock'">
  @if (history$ | async) {
    @if (parseError) {
      <p class="parse-error">{{ 'application.history.parse-error' | translate }}</p>
    }

    @if (historyElementList.length) {
      @for (element of historyElementList; track element.content) {
        @if (element.content) {
          <div class="element">
            <div class="content">
              <p class="title">
                {{ element.creationDate }}
              </p>

              @if (element.contentType === historyElementContentType.JSON) {
                <div class="element-modifications">
                  @for (content of element.content; track content.sectionTitle) {
                    <p class="element-section-title">
                      {{ 'application.history.modifications-done-on-tab' | translate }} {{ content.sectionTitle }}
                    </p>
                    @if (content.modifications && content.modifications.length > 0) {
                      <ul class="element-section-modifications-list">
                        @for (modification of content.modifications; track modification.field) {
                          <li>
                            {{ modification.field }} : {{ modification.oldValue }} →
                            <span class="bold">{{ modification.newValue }}</span>
                          </li>
                        }
                      </ul>
                    }
                  }
                </div>
              } @else if (element.contentType === historyElementContentType.STRING) {
                <div class="element-modifications">
                  <p class="element-section-title">{{ element.content[0].strContent }}</p>
                </div>
              } @else if (
                element.contentType === historyElementContentType.STATUS_CHANGE && element.content[0].statusChange
              ) {
                <div class="element-status-change">
                  <span>{{ 'application.history.contract-status-change' | translate }}</span>
                  @if (statusInfo[element.content[0].statusChange.oldStatus].displayChip) {
                    <ml-badge
                      [color]="statusInfo[element.content[0].statusChange.oldStatus].color"
                      [value]="
                        'application.history.status.' +
                          statusInfo[element.content[0].statusChange.oldStatus].translation | translate
                      "
                    />
                    <span> → </span>
                  }
                  @if (statusInfo[element.content[0].statusChange.newStatus].displayChip) {
                    <ml-badge
                      [color]="statusInfo[element.content[0].statusChange.newStatus].color"
                      [value]="
                        'application.history.status.' +
                          statusInfo[element.content[0].statusChange.newStatus].translation | translate
                      "
                    />
                  }
                </div>
              }
            </div>
            <mat-divider></mat-divider>
          </div>
        }
      }
    } @else if (!parseError) {
      <p>{{ 'application.history.no-data' | translate }}</p>
    }
  } @else {
    <ml-loader></ml-loader>
  }
</ml-card-container>
